const NCOSLogo = () => (
  <div style={{ alignSelf: 'center' }}>
    <img src="/assets/img/ncoslogo_45h.png" alt="logo" />
  </div>
);

export default NCOSLogo;
